import React, { useState } from 'react';
import styled from 'styled-components';
import { useSearchUsersLazyQuery } from '../hooks/query'; 
import { UserSearchResult } from './UserSearchResult';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const Title = styled.h1`
  color: #23419a;
  font-size: 2rem;
  margin-bottom: 30px;
  text-align: center;
  font-weight: 600;
`;

const SearchContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
  align-items: center;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 16px 20px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #23419a;
    box-shadow: 0 0 0 3px rgba(35, 65, 154, 0.1);
  }

  &::placeholder {
    color: #999;
  }
`;

const SearchButton = styled.button`
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #23419a;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #1a3278;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(35, 65, 154, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const LoadingMessage = styled.p`
  text-align: center;
  color: #666;
  font-size: 16px;
  padding: 20px;
`;

const ErrorContainer = styled.div`
  background-color: #ffeaea;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
`;

const ErrorMessage = styled.p`
  color: #d32f2f;
  font-weight: 600;
  margin-bottom: 10px;
`;

const ErrorDetails = styled.pre`
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  overflow-x: auto;
  color: #666;
`;

const ResultsContainer = styled.div`
  margin-top: 20px;
`;

export const UserSearch: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchUsers, { data, loading, error }] = useSearchUsersLazyQuery();

    const handleSearch = () => {
        if (searchQuery.trim()) {
            searchUsers({
                variables: {
                    query: searchQuery,
                    limit: 400,
                }
            });
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <Container>
            <Title>Users</Title>
            <SearchContainer>
                <SearchInput
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={handleKeyPress}
                    placeholder="Search users by username..."
                />
                <SearchButton onClick={handleSearch}>
                    {/*<span className="material-icons">search</span>*/}
                    Search
                </SearchButton>
            </SearchContainer>

            {loading && <LoadingMessage>Searching users...</LoadingMessage>}
            
            {error && (
                <ErrorContainer>
                    <ErrorMessage>Error occurred: {error.message}</ErrorMessage>
                    <ErrorDetails>{JSON.stringify(error, null, 2)}</ErrorDetails>
                </ErrorContainer>
            )}
            
            {data?.searchUsers && (
                <ResultsContainer>
                    <UserSearchResult users={data.searchUsers} />
                </ResultsContainer>
            )}
        </Container>
    );
};
